import React from 'react';
import Page from '../components/Page';

const About = () => (
  <Page title="About Us">
    <div className="flex flex-col gap-5 leading-relaxed text-gray-700">
      <p>
        Velocity Learning teaches CSEC and CAPE Mathematics. We keep classes
        small so every student gets attention, work straight from the syllabus,
        and drill past papers until the exam feels familiar.
      </p>
      <p>
        We came through Presentation College Chaguanas and Hillview College,
        where we merited in Mathematics, Additional Mathematics and Pure
        Mathematics, and we all went on to graduate from the University of
        Toronto.
      </p>
      <p>
        We have run crash courses for the last few years with great results.
        What we want to pass on is the technique &mdash; the way we actually
        approached these exams &mdash; so you can do well too.
      </p>
    </div>
  </Page>
);

export default About;
